import request from '@/utils/request'
// 查询区域列表分页
export function fetchList(query) {
    return request({
        url: '/system/region/page',
        method: 'get',
        params: query,
    })
}
// 查询区域列表不分页
export function regionList(query) {
    return request({
        url: '/system/region/list',
        method: 'get',
        params: query,
    })
}
// 查询营业执照
export function tenantCompany(query) {
    return request({
        url: '/system/tenant/company',
        method: 'get',
        params: query,
    })
}
// 点位查询
export function pointList(query) {
    return request({
        url: '/system/region/point/use/list',
        method: 'get',
        params: query,
    })
}
// 查询区域详细
export function getObj(id) {
    return request({
        url: '/system/region/detail?id=' + id,
        method: 'get',
    })
}
// 新增区域
export function addObj(data) {
    return request({
        url: '/system/region/add',
        method: 'post',
        data: data,
    })
}

// 修改区域
export function putObj(data) {
    return request({
        url: '/system/region/edit',
        method: 'post',
        data: data,
    })
}
// 删除区域
export function delObj(data) {
    return request({
        url: '/system/region/delete',
        method: 'post',
        data: data,
    })
}

// 查询区域列表不分页
export function regionListAll(query) {
    return request({
        url: '/upkeep/point/page',
        method: 'get',
        params: query,
    })
}

export function AddAll(data) {
    return request({
        url: '/upkeep/point/add',
        method: 'post',
        data,
    })
}

export function getObj2(id) {
    return request({
        url: '/upkeep/point/detail?id=' + id,
        method: 'get',
    })
}
